import Rails from "@rails/ujs"

(function () {
  const $doc = $(document)

  $doc.on('ajax:send', 'form[data-remote=true]', function () {
    const $form = $(this)
    const $button = $form.find('[data-disable-with]')
    if (!$button.length) return

    $form.on('ajax:complete', function () {
      setTimeout(function () {
        $button.each(function () { Rails.disableElement(this) })
      }, 0)
    })

    $doc.one('turbolinks:before-cache', function () {
      $button.each(function () { Rails.enableElement(this) })
    })
  })
})()
